import { Card, CardContent, Stack, Typography } from '@mui/material'
import { ContainerPositionType } from '@operations/app/api'
import { RadioOffIcon, RadioOnIcon, useMinimalsTheme } from '@tom-ui/ui'
import { OperatorWithYardSelector } from '../../models/yard-selector.model'

interface Props extends OperatorWithYardSelector {
  selectedOptionId?: ContainerPositionType
  id: ContainerPositionType
  title: string
  hasError: boolean | undefined
  orderId?: number | null
  journeyId?: number | null
  cargoUnitNumber: string
  dataCy?: string
  onPositionChange?: (hasSlotSelected: boolean) => void
  onBlockingIssueChange?: (hasBlockingIssue: boolean) => void
  onChange: (id?: ContainerPositionType) => void
}
export const ContainerPositionRadioYardOption = ({
  selectedOptionId,
  id,
  title,
  hasError,
  cargoUnitNumber,
  orderId,
  dataCy,
  journeyId,
  yardSelector,
  onChange,
  onPositionChange,
  onBlockingIssueChange,
}: Props) => {
  const theme = useMinimalsTheme()

  const isSelected = id === selectedOptionId

  const borderColor = hasError ? theme.palette.error.main : theme.palette.grey[300]

  const handleClick = () => {
    onChange(id)
  }

  return (
    <Card
      variant='outlined'
      sx={{
        boxShadow: 'none',
        border: `1px solid ${borderColor}`,
      }}
      onClick={handleClick}
      data-cy={dataCy}
    >
      <CardContent>
        <Stack gap={theme.customSpacing.m}>
          <Stack direction='row' alignItems='center' gap={theme.customSpacing.m}>
            {isSelected ? <RadioOnIcon color='primary' /> : <RadioOffIcon />}
            <Stack>
              <Typography variant='subtitle2'>{title}</Typography>
            </Stack>
          </Stack>

          {yardSelector?.({
            containerNumber: cargoUnitNumber,
            orderId: orderId,
            hasError: hasError,
            journeyId: journeyId,
            onPositionChange: value => onPositionChange?.(!!value),
            onBlockingIssueChange: onBlockingIssueChange,
          })}
        </Stack>
      </CardContent>
    </Card>
  )
}
